import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';
import { Platform } from '@angular/cdk/platform';
import { LaunchNavigatorOptions, LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { DomSanitizer } from '@angular/platform-browser';


declare var google;let k=1;
@Component({
  selector: 'app-vendor-request',
  templateUrl: './vendor-request.component.html',
  styleUrls: ['./vendor-request.component.scss'],
})
export class VendorRequestComponent {
  @ViewChild('map',{static: false}) mapElement: ElementRef;
 loader:boolean = true;
 change:boolean = false;
 reqLen;
 indicator:boolean;
 checkPendingOrder:boolean=false;
 orgFlow:boolean;
 search2;
 notes;
 actions = [
  { name: "Accept", id: '1' },
  { name: "Reject", id: '2' },    
];
actionAllName;
actionAllId;
 url;
 search:any =[];
 search1:any =[];
 pendSingleAll=[];
 cancelId;
 Oid;
 date = new Date()
 btnTrue:boolean=true;
 id;
 serviceInc:boolean=false;
 name;
 trainerFetch: boolean = true;
 conditionPopup:boolean = false;
 show: boolean = true;
 code;
 android;
 items = [];
 Type;
 contactNbrMob;
 status;
 dateFormat;
 sid;
  reasons;
  users:any=[];Name;UserId;orgId;
 pName;
 pColor;
 pMake;
 list: any = []; 
 listDummy: any = [];
 pendingOrders:any=[];
 pModel;
 pIdentity;
 pDate;
 resId;
 pendingItems =[];
 filterDate: any;
category;
cateName;
singItems = [];
pendSingle = [];
cateId;
cate1Id;
contractors;
contractorId;
ContractorName;
filterPop:boolean = false;
Dummypanding;
dummylist;
button:boolean;
confirm:boolean = false;
CancellationPopup:boolean=false;
cancellationId;
cId;
imgView:boolean = false;
yb:boolean=false;
blob1;
image;
minbtn:boolean = true;
maxbtn:boolean = false;
minbtn1:boolean = true;
maxbtn1:boolean = false;
minbtnReq:boolean = true;
maxbtnReq:boolean = false;
types = [
  { name: "Single Service ", serv: '1' },
  { name: "Package Service", serv: '2' },
];
requestTypes = [
  { name: "Change Allocation", id: '1' },
  { name: "Cancel Request", id: '2' }, 
];
requestTypes1 = [
  { name: "Change Allocation", id: '1' },
  // { name: "Cancel Request", id: '2' },    
];
orderTypes = [
  { name: "Change Allocation", id: '1' },
  { name: "Cancel Request", id: '2' }, 
  // { name: "Edit Order", id:'3'},
  // { name: "Add Items",id:'4'},
];
orderTypes1 = [
  { name: "Change Allocation", id: '1' },
  // { name: "Edit Order", id:'3'},
  // { name: "Add Items",id:'4'},
  // { name: "Cancel Request", id: '2' },    
];
reqName;
reqId;
serv;
servName;
newItems:any=[];
clickedImage:any;
changeId;
ChangeInc:boolean = false;
active1:boolean = false;
lat;
lan;
options: CameraOptions = {
  quality: 30,
  destinationType: this.camera.DestinationType.DATA_URL,
  encodingType: this.camera.EncodingType.JPEG,
  mediaType: this.camera.MediaType.PICTURE
}
pendingItemsObj; 
DummypendingObj;
orderItems:any=[]; 
active:boolean=false;
orderItemsAllocated:any=[];
confirmedOrderItems:any=[];
Orderstatus;
showOpen:boolean=false;
buttonName = "Show Active Only";
buttonName1 = "Show Active Only";
filterButtonName="Show YB Only"
requestButtonName="My Request"
serviceLoc:any =[];
userLatLng:any; 
bell:boolean;
custLatLng:any;
custLat:any;
mapView:boolean = true;
map: any;
marker:any;
currentDate;
statusObj =[{id:0 , name :"All"},{id:2 , name :"Confirmed"},{id:7 , name :"Missed"},{id:8 , name :"Not In Place"},{id:3 , name :"Completed"}
];
statusName;
statusId;
popImg;
custName;
spName;
CalDate ;
calDateOnly;
custMob;
routine;
subsStatus;
reqStatus;
ondemand;
subs;
single;
single1;
subsCount;
resCount;
number;
clickValue;
orgObj:any = []
orgObjName;
orgObjId;
orderCount;
filterLength;
filterLength1;
order;
orderAlloc;
orderLen;
nBlob:any;
document;
documentId;
missedData:any=[];
missedCheck:boolean = false;
missedValue;
cancellation;
orderCancellationReason;
missedId;
openAllMap:boolean = true;
mapData:any=[]
criditValue;
data;
config;
config1;
userValue;
srch:boolean=false;
cancelledReasons;
orderCancelledReasonsList;
openDetailPop:boolean=false;
itemOrders:any=[];
listOfItemOrders:any=[];
startdate;
enddate;
fDate;
eDate;
 constructor(public auth: AuthService,public location: LocationService,private router: Router, public handler: HandlerService,
   public service: ApiService,private camera: Camera,private bottomSheet: MatBottomSheet,private platform: Platform,
   private launchNavigator: LaunchNavigator,public sanitizer: DomSanitizer) { }

   ionViewWillEnter(){
    this.active=false;
    sessionStorage.setItem('vendorApp','true');
    this.contractors=[{firstName:"All",userId:undefined,reqRoleApproved:true}];
    sessionStorage.removeItem('employee')
     this.CalDate = this.returnDate(this.date);
     this.currentDate = this.returnDate(this.date);
     sessionStorage.removeItem('vendor')    
     let url = window.location.href; 
    this.dateFormat = this.auth.getDateformat(); 
    this.getConfig()   
     this.getChange();
     this.getDailyStatus();   
     this.getCount();
     this.getOrgs();
     this.getCategory();
     this.getMissedStaticData();
     this.getCancelReason();
     this.getOrderCancelReason();
     var date = new Date();
     this.startdate = new Date(date.getFullYear(), date.getMonth(), 1);
     this.enddate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
     if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')){
          this.getsc1(); 
     }
    }

    getMissedStaticData() {
      this.service.getMissedData().subscribe((res: any) => {
        this.missedData = res;
      })
    }

    getCategory() {
      this.service.getOrgCategory().subscribe((res: any) => {
        if(res){
          this.category = res;
          this.getRequests(undefined);
        }

      })

    }

    getOrgs(){
      this.service.getOrg().subscribe((res:any)=>{
        this.orgObj=res;
        this.orgObj = this.orgObj.filter(res=> { return res.approvalStatus == 2 && res.activeInd==true})
      })
    }


    markedTime(value){
      if(value){
        var x = value.split("T");
        var y = x[1].slice(0, 5);
        return y
      }
    }

    openBottomSheetOrg(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.orgObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if(res){
          this.contractors=[];
          this.ContractorName = "";
          this.statusName = "";
          this.orgObjName = res.name;
          this.orgObjId = res.id;
          this.contractors=[{firstName:"All",userId:undefined,reqRoleApproved:true}];
          this.getsc(res.id); 
        }  
      });
    
    }

    getCount(){
     this.service.summarySubs().subscribe((res:any)=>{
       if(res){
        this.subsCount = res;
        this.getRequest();
        this.getOrderCount();
       }else{
         this.subsCount=0;
         this.getRequest();
         this.getOrderCount();
       }
    })  
    }
    
    getRequest(){
      this.service.summaryReq1().subscribe((res1:any)=>{ 
        if(res1){
          this.resCount = res1;
        }else{
          this.resCount=0;
        }      
    }) 
    }
    getOrderCount(){
      this.service.getSummaryOrder().subscribe((res2:any)=>{
        if(res2){
          this.orderCount = res2;   
          this.number=this.subsCount+this.resCount+this.orderCount;
        }else{
          this.orderCount = 0;   
          this.number=this.subsCount+this.resCount+this.orderCount;
        }
        if(this.number >=1){
          this.bell=true;
        }  
     })
    }

    getsc1(){ 
      this.Oid=localStorage.getItem('organizationId')
      this.service.getUsersByOrg('SC',this.Oid,null).subscribe((res:any) => { 
        this.contractors=res;
        if(this.cateId){
          this.contractors.map(res=>{
            if(res.categoryLists)
            res.categoryLists.map(res1=>{     
             if(res1.categoryId == this.cateId){
             this.cate1Id = res1.categoryId
             Object.assign(res,{vId:this.cate1Id})      
             }
            })
          })
          this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.cateId });
        }else{ 
      this.contractors=this.contractors.concat(res);
      this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved == true});
        }
  },err=>{
    this.handler.err(err)
  })
    }

    getsc(id){
      this.loader = true;
      this.filterPop = false;
      this.Oid=localStorage.getItem('organizationId')
      this.service.getUsersByOrg('SC',id,null).subscribe((res:any) => { 
        this.contractors=res;
        if(this.cateId){
          this.contractors.map(res=>{
            if(res.categoryLists)
            res.categoryLists.map(res1=>{     
             if(res1.categoryId == this.cateId){
             this.cate1Id = res1.categoryId
             Object.assign(res,{vId:this.cate1Id})      
             }
            })
          })
          this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.cateId });
        }else{     
          this.contractors=this.contractors.concat(res);
          this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved == true});
        }  
      this.loader = false;
      this.filterPop = true;
  },err=>{
    this.handler.err(err)
  })
  }

  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
    setTimeout(() => {
      this.filterLength1 = sessionStorage.getItem('len1')
    }, 1000);
  }

 getRequests(vId) {
   this.search1="";
  this.show = true;
  this.minbtn=true;
  this.checkPendingOrder=false;
  this.maxbtn=false;
  if(this.filterButtonName=="Show All")
  vId=undefined;
   this.loader = true;
  this.url = window.location.href; 
  this.id = localStorage.getItem('organizationId');
  this.cId = localStorage.getItem('currentUserId');
  let post = {
    "fromDate": this.returnDate(this.date),
    "toDate": this.returnDate(this.date),
     statuses:[2,3,7,8],
     ...!(this.auth.checkCapability ('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))||vId?{vendorId:this.id}:{}
  } 
   this.change = false;
   this.service.getAppointReq2(post).subscribe((res: any) => {
    if (res != null && res != "NO_CONTENT") {
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(dat.custItem){
          if(dat.custItem.identificationNo != null ||dat.custItem.identificationNo != ""  ){
            Object.assign(dat,{bikeNumber:dat.custItem.identificationNo});
          }
        }
        
        if(todaysDate < inputDate1){ 
          Object.assign(dat,{present:true});
        }
      })
      this.mapData = res.filter(res => { return res.id == 11089 });
       this.newItems = res;   
       this.documentId = this.newItems.documentId;
       this.dummylist = res;     
       this.items = this.newItems.filter(res =>{return (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 ) && res.subscriptionInd==true})
       this.singItems = this.dummylist.filter(res =>{return  (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 )&& res.subscriptionInd==false})
      //  this.getImage();
      this.getOrdersFunc(vId);
     }else{
       this.items = [] ;
       this.singItems = []; 
       this.getOrdersFunc(vId);   
      //  this.handler.res('No data for you');       
     }
   },err =>{ 
     this.handler.err(err); 
     this.getOrdersFunc(vId);  
   }) 

 }

 getOrdersFunc(vId){
  let post1 = {
    "fromDate": this.returnDate(this.date),
    "toDate": this.returnDate(this.date),
     statuses:[3,10,11],
     ...!(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))||vId?{vendorId:this.id}:{}   
  } 
   this.service.getOrders(post1).subscribe((res: any) => {
    if(res){
    this.confirmedOrderItems = res;  
    res.map(dat=>{
      var a = dat.apptDate.split("T");
      Object.assign(dat,{date:a[0],present:false});
      var b = a[0].split("-");
      var c = b[1]+"/"+b[2]+"/"+b[0];
      var d = b[0]+"-"+b[1]+"-"+b[2];
      var todaysDate = new Date();
      var inputDate = new Date(c);
      var inputDate1 = new Date(d);
      if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
        Object.assign(dat,{present:true});
      }
      if(todaysDate < inputDate1){
        Object.assign(dat,{present:true});
      }
    })
    this.confirmedOrderItems.map(res1=>{
      Object.assign(res1,{custLastName:res1.customer?.firstName})
    })
    this.confirmedOrderItems.map(dat=>{
     this.category.map(dat1=>{   
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
  }) 
  this.loader = false;  
}else{
  this.confirmedOrderItems = [];
  this.loader = false;
}
   },err =>{
    this.loader = false;
    this.handler.err(err); 
  })
 }
 convertTime(tim){
  var time;
  time = tim.split(":");
  return time[0]+":"+time[1]
}

 getImage(id){
   this.loader = true;
   this.service.getDocumentImg(id).subscribe(res=>{  
        this.popImg= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
        this.imgView = true;
        this.loader = false;
      },err =>{
        this.loader = false;
        this.handler.err(err); 
      })
 }

 closePop(){
  this.imgView=false;
  this.popImg = undefined;
 }


 newbook(){
  let post={};  
   this.loader = true;
   this.change = true;
   this.id = localStorage.getItem('organizationId');
   this.status=9;
   this.service.getVenCustItemSubs(this.id,this.status).subscribe((res: any) =>{
    if (res) {
      this.pendingItemsObj = res;  
      this.pendingItems = this.pendingItemsObj.filter(res =>{return res.status == 9 && res.vendorId==this.id})     
      this.pendingItems.map(res1=>{
        Object.assign(res1,{bikeNumber:res1.custItems[0].identificationNo,custFirstName:res1.requestor?.firstName,custLastName:res1.requestor?.lastName})
      })
   
      }else{
        this.loader = false;
       }
  },err =>{
    this.loader = false;
    this.handler.err(err) 
   })
   if(this.auth.checkCapability('FSA') || this.auth.checkCapability('SP') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')){
    this.status=9;
    this.service.getVenAllRequest(this.id,this.status).subscribe((res: any) =>{
      if (res) {
        this.DummypendingObj = res;   
        this.pendSingle =this.DummypendingObj.filter(res =>{return  res.vendorId==this.id&&res.subscriptionInd != null}) ;
       this.single = this.pendSingle.length;     
        this.pendSingle.map(res2=>{    
          Object.assign(res2,{bikeNumber:res2.identificationNumber,custFirstName:res2.requestor?.firstName,custLastName:res2.requestor?.lastName})
         })   
        }else{
        this.loader = false;
       
         }
    },err =>{
      this.loader = false;
      this.handler.err(err) 
     })
     this.service.getAllOrdersByStatus(this.id,this.status).subscribe((res: any) => {
      if(res){
      this.orderItems = res;
      this.order = this.orderItems.length;
      this.orderItems=this.orderItems.filter(res =>{return  res.vendorId==this.id})
      this.orderItems.map(res1=>{
        Object.assign(res1,{custLastName:res1.customer?.firstName})
      })
      this.orderItems.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
    }) 
    this.loader = false;  
  }else{
    this.orderItems = [];
    this.loader = false;
   }
    })
   
   }
   if(this.auth.checkCapability('FSA') || this.auth.checkCapability('SC') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP')){
    this.status=6;
    this.service.getVenAllRequest(this.id,this.status).subscribe((res: any) =>{
      if (res) {
        this.DummypendingObj = res;   
        this.pendSingleAll =this.DummypendingObj.filter(res =>{return  res.vendorId==this.id&&res.subscriptionInd != null}) ;
       this.single1 = this.pendSingleAll.length;  
        this.pendSingleAll.map(res2=>{    
          Object.assign(res2,{bikeNumber:res2.identificationNumber,custFirstName:res2.requestor?.firstName,custLastName:res2.requestor?.lastName})
         })         
        }else{
          this.pendSingleAll=[];
          this.loader = false;
       
         }
    },err =>{
      this.loader = false;
      this.handler.err(err) 
     })
     this.Orderstatus=12;
     this.service.getAllOrdersByStatus(this.id,this.Orderstatus).subscribe((res: any) => {
      if(res){
      this.orderItemsAllocated = res;
      this.orderAlloc = this.orderItemsAllocated.length;
      this.orderItemsAllocated=this.orderItemsAllocated.filter(res =>{return  res.vendorId==this.id})
      this.orderItemsAllocated.map(res1=>{
        Object.assign(res1,{custLastName:res1.customer?.firstName})
      })
      this.orderItemsAllocated.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
    })
    this.loader = false; 
  }else{
    this.orderItemsAllocated = [];
    this.loader = false;

  }
    })
   }
   setTimeout(() => {  
  this.reqLen=this.single+this.single1;
  this.orderLen=this.order+this.orderAlloc;
   }, 3000);
  
 }

 

 assignVendor(data,id){
  let url = window.location.href;  
  if(url.includes('orgRequest') ){
    this.router.navigate(['/assignVendor/', +id]);
  } else{
      sessionStorage.setItem('catId',data.providerService.itemCategoryId)
      this.router.navigate(['/assign-employee/', +id]);
  }
 }

 changeVendor(data,id){
  sessionStorage.setItem('catId',data.providerService.itemCategoryId)
  this.router.navigate(['/change-Alloc/', +id]);
 }

 assignVendor1(data,id){
  let url = window.location.href;  
  if(url.includes('orgRequest') ){ 
    this.router.navigate(['/packageAssign/', +id]);
  } else{
      sessionStorage.setItem('catId',data.providerService.itemCategoryId)
    this.router.navigate(['/assign-employee/', +id]);
  }
 }

 next() {
  this.buttonName = "Show Active Only"
  this.filterButtonName = "Show YB Only"
  let x = new Date(JSON.parse(JSON.stringify(this.CalDate)));
  let newDate = new Date(x.setDate(x.getDate() + 1));
  this.CalDate = newDate;
  this.date= new Date(newDate);
  this.rangeDate()
}

prev() {
  this.buttonName = "Show Active Only"
  this.filterButtonName = "Show YB Only"
  let x = new Date(JSON.parse(JSON.stringify(this.CalDate)));
  let newDate = new Date(x.setDate(x.getDate() - 1));
  this.CalDate = newDate;
  this.date= new Date(newDate);
  this.rangeDate()
}

 
 rangeDate() {
  this.active1 = false;
  this.loader = true;
  let post = {
    "fromDate": this.returnDate(this.CalDate),
    "toDate": this.returnDate(this.CalDate),
    statuses:[2,3,7,8],
    ...this.filterButtonName=="Show All"||!(this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))?{vendorId:this.id}:{}
  }
  this.service.getAppointReq2(post).subscribe((res: any) => {
    if (res != null && res != "NO_CONTENT") {
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:false});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(todaysDate < inputDate1){
          Object.assign(dat,{present:true});
        }
      })
      this.newItems = res;   
       this.dummylist = res;
       this.items = this.newItems.filter(res =>{return (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 ) && res.subscriptionInd==true})
       this.singItems = this.dummylist.filter(res =>{return  (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 )&& res.subscriptionInd==false});
       this.loader=false;
      }


    else {
      this.items = [];
      this.singItems = [];
      this.loader=false;
      // this.handler.res('No Appointments  For You')
    }
    this.filterDate = "";

  }, err => {
    this.filterDate = "";
    this.loader = false;
    this.handler.err(err)
  })
  this.loader=true;
  let post1 = {
    "fromDate": this.returnDate(this.CalDate),
    "toDate": this.returnDate(this.CalDate),
    statuses:[3,10,11],
    ...this.filterButtonName=="Show All"||!(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))?{vendorId:this.id}:{}
  } 
   this.service.getOrders(post1).subscribe((res: any) => {
    if(res){
    this.confirmedOrderItems = res;
    res.map(dat=>{
      var a = dat.apptDate.split("T");
      Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
      var b = a[0].split("-");
      var c = b[1]+"/"+b[2]+"/"+b[0];
      var d = b[0]+"-"+b[1]+"-"+b[2];
      var todaysDate = new Date();
      var inputDate = new Date(c);
      var inputDate1 = new Date(d);
      if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
        Object.assign(dat,{present:true});
      }
      if(dat.custItem){
        if(dat.custItem.identificationNo != null ||dat.custItem.identificationNo != ""  ){
          Object.assign(dat,{bikeNumber:dat.custItem.identificationNo});
        }
      }
      
      if(todaysDate < inputDate1){
        Object.assign(dat,{present:true});
      }
    })
    this.confirmedOrderItems.map(res1=>{
      Object.assign(res1,{custLastName:res1.customer?.firstName})
    })
    this.confirmedOrderItems.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
  })
  this.loader = false; 
}else{
  this.loader=false;
  this.confirmedOrderItems=[];
} }, err => {
  this.filterDate = "";
  this.loader = false;
  this.handler.err(err)
  })
}

 assignEmp(id,item){
    sessionStorage.setItem('catId',item.providerService.itemCategoryId)
    sessionStorage.setItem('vendor',item.vendorId)
   this.router.navigate(['/assign-employee/', +id]);
 }


 
 assignEmp1(id,item){
    sessionStorage.setItem('catId',item.services[0].itemCategoryId)
    sessionStorage.setItem('vendor',item.vendorId)
   this.router.navigate(['/packAssign-emp/', +id]);
 }
 

 returnDate(data) {
  let date = data.getDate();
  date = date < 10 ? '0' + date : date;
  let month = data.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let year = data.getFullYear();
  return year + '-' + month + '-' + date;
}

dateSearch() {
 // this.loader = true;
 let month = this.date.getMonth() + 1;
 var fmon;
 month < 10 ? fmon = '0' + month : fmon = month;
 let day = this.date.getDate();
 var fday;
 day < 10 ? fday = '0' + day : fday = day;
 let date = fday + '-' + fmon + '-' + this.date.getFullYear();
 let post = {
   "schElements": [1],
   "requestDate": date,
   "status": ["SlotsAvailable"],
   trainerFetch: this.trainerFetch
 }

}

Vendorselect(id){
 this.router.navigate(['/assignVendor/', +id]);

}

openPop(data){
 this.serviceInc=true
  this.pName=data.providerService.name;
  this.custName = data.custItem.custName ;
  this.custMob = data.custItem.contactNbrMob;
  this.pColor=data.custItem.colour;
  this.pMake=data.custItem.make;
  this.pModel=data.custItem.model;
  this.pIdentity=data.custItem.identificationNo; 
  this.spName = data.serviceContractor.firstName+ " " +data.serviceContractor.lastName

}

openPop1(data){
  this.serviceInc=true
  this.pName=data.services[0].name;
  this.pColor=data.custItems[0].colour;
  this.pMake=data.custItems[0].make;
  this.pModel=data.custItems[0].model;
  this.pIdentity=data.custItems[0].identificationNo;
  this.custName = data.custItems[0].custName ;
  this.custMob = data.custItems[0].contactNbrMob;
  this.contractors.map(res=>{
    this.spName = data.serviceContractor.firstName+ " " +data.serviceContractor.lastName
 
})
}


ionViewWillLeave(){
 this.Name = undefined;
 this.active1 = false;
 this.ContractorName="";
 this.contractorId="";
 this.statusName="";
 this.statusId="";
 this.orgObjName="";
 this.orgObjId="";
 this.cateName="";
 this.cateId="";
 this.newItems = [];   
  this.dummylist = [];
  this.items = [];
  this.singItems = [];
  this.loader = true;
  this.search=[];
  this.search1=[];
  this.search = "";
  this.search1="";
  this.openAllMap = true;
  this.cancelFilter();
  }

refreshData(event){
  if(!this.change){
    this.ionViewWillEnter();
  }else{
    this.newbook();
  }
  setTimeout(() => {
    event.target.complete();
  }, 1000);
}

cancelFilter() {
  this.loader = true;
  this.ContractorName = "";
  this.contractorId="";
  this.servName = "";
  this.statusName = "";
  this.statusId = "";
  this.cateName ="";
  this.cateId = "";
  this.serv = "";
  this.orgObjName= "";
  this.orgObjId="";
  this.getRequests(undefined);
  this.filterPop = false;
}

searchfilter() {
  this.loader = true;
  if(this.statusId || this.contractorId || this.orgObjId || this.cateId){
  this.items = this.newItems.filter(res=>{
    return (this.cateId? res.categoryId == this.cateId:res.categoryId) && (this.contractorId? res.serviceContractorId == this.contractorId:res.serviceContractorId) && (this.orgObjId? res.vendorId == this.orgObjId:res.vendorId) &&(this.statusId>0? res.status == this.statusId:res.status) &&(this.buttonName =="Show All"? res.status ==2:res.status) && res.subscriptionInd==true});
  this.singItems = this.dummylist.filter(res=>{
    return (this.cateId? res.categoryId == this.cateId:res.categoryId) && (this.contractorId? res.serviceContractorId == this.contractorId:res.serviceContractorId) && (this.orgObjId? res.vendorId == this.orgObjId:res.vendorId) &&(this.statusId>0? res.status == this.statusId:res.status) &&(this.buttonName =="Show All"? res.status ==2:res.status) && res.subscriptionInd==false});
  this.filterPop=false;
  }
  else{
    this.handler.res("Please select value from dropdown to filter")
    this.filterPop=false;
  }
  setTimeout(() => {
    this.loader = false;
  }, 1500);
  
}

searchByContractor() {
  this.items = this.items.filter(res => {
    return res.employee.userId == this.contractorId
  })
  this.filterPop = false;

}

openBottomSheetCon(): void {
  if(!this.active1 && this.orgObjId ){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.contractors,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.statusName = ""
    this.contractorId = res.userId;
    if(res.lastName)
    this.ContractorName = res.firstName ;
    else
    this.ContractorName = res.firstName;
  });
}
}

openBottomSheetCon1(): void {
  if(!this.active1){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.contractors,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.statusName = ""
    this.contractorId = res.userId;
    if(res.lastName)
    this.ContractorName = res.firstName + res.lastName;
    else
    this.ContractorName = res.firstName;
  });
}
}

openBottomSheetStatus(): void {
  // if(this.buttonName=='Show Active Only'){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.statusObj,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.statusName = res.name;
    this.statusId = res.id;
  });
// }
}

openBottomSheetStatus1(): void {
  // if(this.buttonName=='Show Active Only'){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.statusObj,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.statusName = res.name;
    this.statusId = res.id;
  });
// }
}

openBottomSheetReqTypes(data,id): void {
  if(data.status==2){
  sessionStorage.setItem('employee',data.serviceContractorId)
  this.id = localStorage.getItem('organizationId');
  if(((this.auth.checkCapability('SP') || this.auth.checkCapability('FSA')  ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP') )) && (this.id==790)){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.requestTypes,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
        this.reqName = res.name;
        this.reqId = res.id;
        if(this.reqId == 1){      
            sessionStorage.setItem('catId',data.providerService.itemCategoryId) 
            sessionStorage.setItem('vendor',data.vendorId)          
              this.router.navigate(['/change-Alloc/', +id]);
        }else{
          this.confirm = true;
          this.cancelId = id;
          if(data.subscriptionInd){
            this.indicator=true;
          }else{
            this.indicator=false; 
          }
        
        }
      
      }
    });
  }else if((this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA') )){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.requestTypes1,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
        this.reqName = res.name;
        this.reqId = res.id;
        if(this.reqId == 1){      
            sessionStorage.setItem('catId',data.providerService.itemCategoryId) 
            sessionStorage.setItem('vendor',data.vendorId)          
              this.router.navigate(['/change-Alloc/', +id]);
        }else{
          this.confirm = true;
          this.cancelId = id;
          if(data.subscriptionInd){
            this.indicator=true;
          }else{
            this.indicator=false; 
          }
        }
      }
    });
  }else{ 
    this.handler.res("No Actions Found")
  }
}else{
  this.handler.res("No Actions Found")
}

}

orderEdit(data){
  sessionStorage.setItem('orderId',data.id);
  sessionStorage.setItem('catId',data.categoryId);
  sessionStorage.setItem('vendor',data.vendorId);
  this.router.navigate(['vendor-order-edit/',+data.categoryId])
}

newOrderEdit(data){
  sessionStorage.setItem('orderId',data.id);
  this.router.navigate(['vendor-new-order/',+data.categoryId])
}


openBottomSheetOrderTypes(data,id): void {
  if(data.status==10){
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId',data.categoryId);
    sessionStorage.setItem('vendor',data.vendorId);
  this.id = localStorage.getItem('organizationId');
  if(((this.auth.checkCapability('SP') || this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP') )) && (this.id==790)){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orderTypes,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
        this.reqName = res.name;
        this.reqId = res.id;
        if(this.reqId == 1){      
          this.router.navigate(['/AssigningEmp/', +id]);
        }
        if(this.reqId==3){
          this.router.navigate(['vendor-order-edit/',+data.categoryId])
        }
        if(this.reqId==4){
          this.router.navigate(['/vendor-Purchase-category'])
        }
          if(this.reqId==2){
            this.confirm = true;
            this.cancelId = id;
            if(data.subscriptionInd){
              this.indicator=true;
            }else{
              this.indicator=false; 
            }
          }
        
      }
    });
  }else if((this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA') )){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.orderTypes1,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
        this.reqName = res.name;
        this.reqId = res.id;
        if(this.reqId == 1){      
          this.router.navigate(['/AssigningEmp/', +id]);
        }
        if(this.reqId==3){
          this.router.navigate(['vendor-order-edit/',+data.itemCategoryId])
        }
        if(this.reqId==4){
          this.router.navigate(['/vendor-Purchase-category'])
        }
        if(this.reqId==2){
          this.confirm = true;
          this.cancelId = id;
          if(data.subscriptionInd){
            this.indicator=true;
          }else{
            this.indicator=false; 
          }
        }
      }
    });
  }else{ 
    this.handler.res("No Actions Found")
  }
}else{
  this.handler.res("No Actions Found")
}

}


openBottomSheetSer(): void {
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.types,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    this.servName = res.name;
    this.serv = res.serv;
  });
}


filterReq(){
  this.filterPop = true;
}

getReason(id){
  this.resId=id;
  this.ChangeInc=true;
}

getMissed(id){
  this.missedId = id;
  this.missedCheck = true ;
}

getChange(){
  this.service.getReasons().subscribe(res =>{ 
    this.reasons = res;
  }) 
}

getCancelReason(){
  this.service.getcancellationReason().subscribe(res =>{ 
    this.cancelledReasons = res;
   
  }) 
}

getOrderCancelReason(){
  this.service.getcancellationReason().subscribe(res =>{ 
    this.orderCancelledReasonsList = res;
   
  }) 
}
openImage(data){
  this.popImg = data;
  this.imgView = true;
}

captureImage(id) {
  if (this.platform.ANDROID || this.platform.IOS){
    this.camera.getPicture(this.options).then((imageData:any) => {
      if(imageData){
        let base64Image = 'data:image/jpeg;base64,' + imageData;
        this.clickedImage = base64Image;
        this.NotInPlace(id);
      }else{
        this.blobData(id)
      }     
    }); 
  }else{
    this.blobData(id)
    }
}

blobData(id){
  var xhr = new XMLHttpRequest();       
  xhr.open("GET", "assets/icon/seden.jpeg", true); 
  xhr.responseType = "blob";
  var obj=this;
  xhr.onload = function (e) {
  var reader = new FileReader();
  reader.onload = function(event) {
      var res = event.target.result;
  }
  obj.nBlob = this.response;
  reader.readAsDataURL(obj.nBlob);
  obj.NotInPlace(id);
  };
  xhr.send() 
}

 DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)
  return new Blob([ia], { type: mimeString })
}


NotInPlace(id){
  this.loader=true;
  let y = this.status.find(res => res.name == "NotInPlace");
  let a =y.id;
  var file
  if (this.platform.ANDROID || this.platform.IOS){
     file = this.DataURIToBlob(this.clickedImage)
  }else{
     file = this.nBlob;
  }
  setTimeout(() => {
    this.service.notInPlace(id,a,file).subscribe((res:any)=>{
      sessionStorage.setItem("clickValue",id)
      this.handler.res('Status Updated Successfully !!')
      if(this.orgObjId || this.contractorId || this.statusId){
        this.getRequests1(undefined);
      }else{
        this.getRequests(undefined)
      }
       },
    err=>{
      this.loader=false;
      this.handler.err(err)
    })
  }, 1000);
 
}

Missed(){
  this.loader = true;
  this.missedCheck = false;
  let y = this.status.find(res => res.name == "Missed");
  let a =y.id;
  let post = {
    "id":this.missedId,
    "status": a,
    "missedReasons":this.missedValue
    }
  this.service.missed(post ,this.missedId).subscribe((res:any)=>{
    sessionStorage.setItem("clickValue",this.missedId)
    this.handler.res('Status Updated Successfully !!')
    this.missedCheck=false;
    if(this.orgObjId || this.contractorId || this.statusId){
      this.getRequests1(undefined);
    }else{
      this.getRequests(undefined)
    }
   
    // this.loader=false;
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

getRequests1(vId) {
  vId=undefined;
   this.loader = true;
  var date = new Date();
  this.url = window.location.href; 
  this.id = localStorage.getItem('organizationId');
  this.cId = localStorage.getItem('currentUserId');
  let post = {
    "fromDate": this.returnDate(date),
    "toDate": this.returnDate(date),
     statuses:[2,3,7,8],
     ...!(this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))||vId?{vendorId:this.id}:{}
  } 
   this.change = false;
   this.service.getAppointReq2(post).subscribe((res: any) => {
    if (res != null && res != "NO_CONTENT") {
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(dat.custItem){
          if(dat.custItem.identificationNo != null ||dat.custItem.identificationNo != ""  ){
            Object.assign(dat,{bikeNumber:dat.custItem.identificationNo});
          }
        }
        
        if(todaysDate < inputDate1){
          Object.assign(dat,{present:true});
        }
      })
       this.newItems = res;   
       this.dummylist = res;
     
       this.items = this.newItems.filter(res =>{return (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 ) && res.subscriptionInd==true})
       this.singItems = this.dummylist.filter(res =>{return  (res.status == 2 ||res.status == 3 ||res.status == 7 ||res.status == 8 )&& res.subscriptionInd==false})
       this.items = this.items.filter(res=>{
        return (this.orgObjId? res.vendorId == this.orgObjId:res.vendorId) && (this.contractorId? res.serviceContractorId == this.contractorId:res.serviceContractorId) &&(this.statusId>0? res.status == this.statusId:res.status) });

        this.singItems = this.singItems.filter(res=>{
        return (this.orgObjId? res.vendorId == this.orgObjId:res.vendorId) && (this.contractorId? res.serviceContractorId == this.contractorId:res.serviceContractorId) &&(this.statusId>0? res.status == this.statusId:res.status) });
        this.loader = false;  
       
       
     }else{
       this.items = [] ;
       this.singItems = [];
       this.loader = false;
      //  this.handler.res('No data for you');       
     }
   },err =>{
     this.loader = false;
     this.handler.err(err); 
   })
   let post1 = {
    "fromDate": this.returnDate(this.date),
    "toDate": this.returnDate(this.date),
     statuses:[3,10,11],
     ...!(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))||vId?{vendorId:this.id}:{}       
  } 
   this.service.getOrders(post1).subscribe((res: any) => {
    if(res){
    this.confirmedOrderItems = res;
    res.map(dat=>{
      var a = dat.apptDate.split("T");
      Object.assign(dat,{date:a[0],present:false});
      var b = a[0].split("-");
      var c = b[1]+"/"+b[2]+"/"+b[0];
      var d = b[0]+"-"+b[1]+"-"+b[2];
      var todaysDate = new Date();
      var inputDate = new Date(c);
      var inputDate1 = new Date(d);
      if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
        Object.assign(dat,{present:true});
      }
      if(todaysDate < inputDate1){
        Object.assign(dat,{present:true});
      }
    })
    this.confirmedOrderItems.map(res1=>{
      Object.assign(res1,{custLastName:res1.customer?.firstName})
    })
    this.confirmedOrderItems.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
  }) 
  this.confirmedOrderItems = this.confirmedOrderItems.filter(res=>{
    return (this.orgObjId? res.vendorId == this.orgObjId:res.vendorId) && (this.contractorId? res.serviceContractorId == this.contractorId:res.serviceContractorId) &&(this.statusId>0? res.status == this.statusId:res.status) });
    this.loader=false;
  }else{
    this.confirmedOrderItems=[];
  this.loader=false;
}

  })
 
 }

getDailyStatus(){
  this.service.getDailyStatus().subscribe(res =>{ 
    this.status = res;
  }) 
}

Completed(id){
  this.loader = true;
  let y = this.status.find(res => res.name == "Completed");
  let a =y.id;
  let post = {
    "id":id,
    "status": a,
   }
     this.service.completed(post,id).subscribe((res:any)=>{
    sessionStorage.setItem("clickValue",id)
    this.handler.res('Status Updated Successfully !!')
    if(this.orgObjId || this.contractorId || this.statusId){
      this.getRequests1(undefined);
    }else{
      this.getRequests(undefined)
    }
    // this.loader=false;
    
  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  })
}

updateReason(){
  this.loader=true;
  let post = {
    "id":this.resId,
    "status": 2,
    "reason":this.changeId  
  }
  this.service.updateReasons(post,this.resId).subscribe((res:any)=>{
    this.handler.res('Status Updated Successfully !!')
    this.Type="";
    if(this.orgObjId || this.contractorId || this.statusId){
      this.getRequests1(undefined);
    }else{
      this.getRequests(undefined)
    }
    // this.loader=false;

  },
  err=>{
    this.loader=false;
    this.handler.err(err)
  }) 
}
clearCapture(){
  this.clickedImage = ""
  this.ChangeInc = false;
  this.updateReason();
}
cancel(){
   this.confirm = false;
if(this.indicator){
  this.cancelOrder();
}else{
  this.orderCancellation();
}
}
cancelOrder(){   
  this.loader = true;
  var post={
    "cancellationReasons":this.cancellation
  }
  this.service.cancelReq(this.cancelId,post).subscribe((res: any) => {
    this.handler.res("Cancelled successfully"); 
    this.confirm=false;
    this.loader = false;
    this.getRequests(undefined)
  }, err => {
    this.loader = false;
    this.handler.err(err)
  })
}

clearArray(value){
  this.changeId=value.id;
}

clearArray1(value){
  this.missedValue=value.id;
}

clearArray2(value){
  this.cancellation=value.name;
}

clearArray3(value){
  this.orderCancellationReason=value.name;
}


openMap(data) {
  if (this.platform.ANDROID || this.platform.IOS) {
    navigator.geolocation.getCurrentPosition(res => {
     this.lat = res.coords.latitude, 
     this.lan = res.coords.longitude;
    },
      err => {
        this.handler.err(err)
      })
  }
  if(data.address){
    var cLat = data?.address?.lat;
    var cLon = data?.address?.lon;
  }else{
    var cLat = data?.lat;
    var cLon = data?.lon;
  }

  if(cLat != "" && cLon != "" ){
    this.mapView=false;
    setTimeout(() => {
      this.userLatLng = [this.lat, this.lan];
      this.custLat = [cLat,cLon];
      this.custLatLng = new google.maps.LatLng(cLat,cLon);
      let pos = new google.maps.LatLng(this.lat, this.lan);
      let mapOptions = {
        center: pos,
        zoom: 100,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: pos,
        animation: google.maps.Animation.DROP,
        map: this.map
      });
      this.startNavigating(pos)
    }, 2000);
  }else{
    var err="Address Not Found"
    this.handler.err(err)
  }
  

}


startNavigating(pos) {
  let directionsService = new google.maps.DirectionsService;
  let directionsDisplay = new google.maps.DirectionsRenderer;
  directionsDisplay.setMap(this.map);
  directionsService.route({
    origin: pos,
    destination: this.custLatLng,
    travelMode: google.maps.TravelMode['DRIVING']
  }, (res, status) => {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(res);
    } else {
    }
  });
}

navigate(){
  let options: LaunchNavigatorOptions = {
    start: this.userLatLng,
  }
  this.launchNavigator.navigate(this.custLat, options)
    .then(
      success => this.mapView = false
    );
}


getId(data){
  if(data.custItems){
    if(data.custItems[0]){
      return data.custItems[0]?.identificationNo
    }
  }
}

openBottomSheet() {
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.category,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if (res) {
      this.cateName = res.name;
      this.cateId = res.id;
      this.orgObjName="";
      this.orgObjId="";
      this.ContractorName="";
      this.contractorId="";   
    }
  });
}

minimize(){
  this.show = false;
  this.maxbtn = true;
  this.minbtn = false;
}

maximize(){
  this.show = true;
  this.minbtn = true;
  this.maxbtn = false;
}


openMap1(){
  if(this.platform.ANDROID){
    navigator.geolocation.getCurrentPosition(res => {
      this.lat = res.coords.latitude, 
      this.lan = res.coords.longitude;
     },
       err => {
         this.handler.err(err)
       })
  }
  this.loader=true;
  this.openAllMap=false;
  setTimeout(() => {
    let pos= new google.maps.LatLng(this.lat,this.lan);
    let mapOptions = {
      center: pos,
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    var icon='assets/pin.png';
    if(this.items &&this.items.length>0){
    this.items.map(res=>{
      if(res.address?.lat && res.address?.lon){
        let lat=Number(res.address.lat)
        let lon=Number(res.address.lon)
        this.marker= new google.maps.Marker({
          position: new google.maps.LatLng(lat,lon),
          animation: google.maps.Animation.DROP,
          map: this.map,
          icon:icon
        });
        var infoWindow = new google.maps.InfoWindow({
          content:res.requestor.firstName
      });
       infoWindow.open(this.map,this.marker);
      }    
      }
    )
  }
  this.loader=false;
  }, 1000);
}
getServiceName(data){
  if(data.services){
    if(data.services[0]){
      return data.services[0]?.name
    }
  }
}

mini(){
  this.show = false;
  this.maxbtn1 = true;
  this.minbtn1 = false;
}

max(){
  this.show = true;
  this.minbtn1 = true;
  this.maxbtn1 = false;
}

openBottomSheetItemAction(data){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.actions,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if (res) {
      this.actionAllName = res.name;
      this.actionAllId = res.id;
      if(this.actionAllId==1){
        this.accept(data);
      }
      if(this.actionAllId==2){
        this.reject(data);
      }
         }
  });
}
reject(data){
  this.loader=true;
  this.service.RequestReject(data.id).subscribe(res=>{
    this.loader=false;
    this.handler.res('Request rejected sucessfully!!!')
    this.getRequests(undefined);
    this.getCount();
  })
}

openBottomSheetOrderAction(data){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.actions,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if (res) {
      this.actionAllName = res.name;
      this.actionAllId = res.id;
      if(this.actionAllId==1){
        this.acceptOrder(data);
      }
      if(this.actionAllId==2){
        this.rejectOrder(data);
      }
         }
  });
}
rejectOrder(data){
this.loader=true;  
this.service.OrderReject(data.id).subscribe(res=>{
  this.loader=false;
  this.handler.res('Order rejected sucessfully!!!')
  this.getRequests(undefined)
  this.getCount();
})
}

acceptOrder(data){
  this.loader = true;
  this.url = window.location.href;
    let post = {
    "apptDate":data.apptDate,
    "serviceContractorId":data.serviceContractorId,
    "targetSource": data.serviceContractorId,
    "apptEndTime":data.apptEndTime,
    "apptTime":data.apptTime,
    }
  
  let url = window.location.href;   
    this.service.confirmEmpOrder(data.id,post).subscribe(res => {
     this.loader = false;
      this.handler.res('Order Confirmed Successfully !!');
      this.getRequests(undefined);
      this.getCount(); 
  })
}

accept(data){
  this.loader = true;
  this.url = window.location.href;
    let post = {
    "apptDate":data.apptDate,
    "serviceContractorId": data.serviceContractorId,
    "targetSource": data.serviceContractorId,
    "apptEndTime":data.apptEndTime,
    "apptTime":data.apptTime,
    }
  
  let url = window.location.href;   
    this.service.confirmEmpReq(data.id,post).subscribe(res => {
     this.loader = false;
     this.getRequests(undefined)
     this.getCount();
      this.handler.res('Request Confirmed Successfully !!');
      // this.router.navigate(['/vendor-request']);    
       
  })
}
clear(){
    this.search="";
    this.search1="";
  }

  popUpOpen(data){
    this.itemOrders = data.itemOrders;
    this.notes = data.notes;
    this.openDetailPop = true;
  }

  assignEmpForOrder(data, id) {
    sessionStorage.setItem('orderId',data.id);
    sessionStorage.setItem('catId',data.categoryId);
    sessionStorage.setItem('vendor',data.vendorId)
    this.router.navigate(['/AssigningEmp/', +id]);
  }

  orderCancellation(){   
    this.loader = true;
    var post={
      "cancellationReasons":this.cancellation
    }
    this.service.cancelOrder(this.cancelId,post).subscribe((res:any)=>{
      this.handler.res("Cancelled successfully"); 
      this.confirm=false;
      this.loader = false;
      this.getRequests(undefined)
    }, err => {
      this.loader = false;
      this.handler.err(err)
    })
  }

  openOrderRequests(data){
  this.router.navigate(['/order-requests/',data.id])
  }



changeApp(){
  sessionStorage.setItem('vendorApp','false')
  if(this.active){
    if(this.auth.loged()){
      this.router.navigate(['/bookservice1']) 
    }else{
      this.router.navigate(['/bookservice']) 
    }

  }else{
    if(this.auth.loged()){
      this.router.navigate(['/vendor-register1'])
    }else{
      this.router.navigate(['/vendor-register'])
    }
   
  }
}

pendingActions(){
  this.loader=true;
  this.checkPendingOrder=true;
  if(this.auth.checkCapability('FSA')){
    var start = this.returnDate(this.startdate);
    var end = this.returnDate(this.enddate) 
    this.status=10
    this.service.getAllOrdersOnly(this.status,start,end).subscribe((res: any) => {
      if(res){
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(todaysDate < inputDate1){ 
          Object.assign(dat,{present:true});
        }
      })  
      this.pendingOrders = res;
      this.order = this.pendingOrders.length;
      this.pendingOrders=this.pendingOrders.filter(res =>{return  res.vendorId==this.id})
      this.pendingOrders.map(res1=>{
        Object.assign(res1,{custLastName:res1.customer?.firstName})
      })
      this.pendingOrders.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
    }) 
    this.loader = false;  
  }else{
    this.pendingOrders = [];
    this.loader = false;
   }
    }) 
  }else{
  this.status=10
  var start = this.returnDate(this.startdate);
  var end = this.returnDate(this.enddate) 
  this.service.getAllOrdersByDate(this.id,this.status,start,end).subscribe((res: any) => {
    if(res){
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:true});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
      })   
    this.pendingOrders = res;
    this.order = this.pendingOrders.length;
    this.pendingOrders=this.pendingOrders.filter(res =>{return  res.vendorId==this.id})
    this.pendingOrders.map(res1=>{
      Object.assign(res1,{custLastName:res1.customer?.firstName})
    })
    this.pendingOrders.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
  }) 
  this.loader = false;  
}else{
  this.pendingOrders = [];
  this.loader = false;
 }
  }) 
}
}
startDate(){
  this.fDate=this.returnDate(this.startdate);
  this.enddate=""
 }
 endDate(){
  this.loader=true;
  this.checkPendingOrder=true;
  if(this.auth.checkCapability('FSA')){
    this.fDate=this.returnDate(this.startdate);
    this.eDate=this.returnDate(this.enddate);
    this.status=10
    this.service.getAllOrdersOnly(this.status,this.fDate,this.eDate).subscribe((res: any) => {
      if(res){
        res.map(dat=>{
          var a = dat.apptDate.split("T");
          Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
          var b = a[0].split("-");
          var c = b[1]+"/"+b[2]+"/"+b[0];
          var d = b[0]+"-"+b[1]+"-"+b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
            Object.assign(dat,{present:true});
          }
          if(todaysDate < inputDate1){ 
            Object.assign(dat,{present:true});
          }
        })    
      this.pendingOrders = res;
      this.order = this.pendingOrders.length;
      this.pendingOrders=this.pendingOrders.filter(res =>{return  res.vendorId==this.id})
      this.pendingOrders.map(res1=>{
        Object.assign(res1,{custLastName:res1.customer?.firstName})
      })
      this.pendingOrders.map(dat=>{
       this.category.map(dat1=>{
         if(dat.categoryId==dat1.id)
         Object.assign(dat, {categoryName: dat1.name})   
       })
    }) 
    this.loader = false;  
  }else{
    this.pendingOrders = [];
    this.loader = false;
   }
    }) 
  }else{
  this.status=10
  this.service.getAllOrdersByDate(this.id,this.status,this.fDate,this.eDate).subscribe((res: any) => {
    if(res){
      res.map(dat=>{
        var a = dat.apptDate.split("T");
        Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
        var b = a[0].split("-");
        var c = b[1]+"/"+b[2]+"/"+b[0];
        var d = b[0]+"-"+b[1]+"-"+b[2];
        var todaysDate = new Date();
        var inputDate = new Date(c);
        var inputDate1 = new Date(d);
        if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
          Object.assign(dat,{present:true});
        }
        if(todaysDate < inputDate1){ 
          Object.assign(dat,{present:true});
        }
      })   
    this.pendingOrders = res;
    this.order = this.pendingOrders.length;
    this.pendingOrders=this.pendingOrders.filter(res =>{return  res.vendorId==this.id})
    this.pendingOrders.map(res1=>{
      Object.assign(res1,{custLastName:res1.customer?.firstName})
    })
    this.pendingOrders.map(dat=>{
     this.category.map(dat1=>{
       if(dat.categoryId==dat1.id)
       Object.assign(dat, {categoryName: dat1.name})   
     })
  }) 
  this.loader = false;  
}else{
  this.pendingOrders = [];
  this.loader = false;
 }
  }) 
}

}
async getConfig(){
  this.data= await this.service.getConfig().toPromise();
  if(this.data){
     let x= this.data.find(res=>res.name=="Billing Config");
     this.config=x.configs.find(dat=>dat.shortCdConst=="TVC");
     this.config1 = x.configs.find(dat=>dat.shortCdConst=="ACP");
     this.userValue=this.config.userValue; 
     this.criditValue=this.config1.userValue;

  }
}

}
